import { OfferData } from '../domain/offerData.model'
import { OfferDocumentDTO } from '../domain/offerDocument.dto'
import OfferRepository from '../repository/offer.repository'

export default {
  initOffer: async function() {
    try {
      const document = await OfferRepository.initOffer()
      return document.data
    } catch (error) {
      console.log(error)
    }
  },

  discardOffer: function(offerId: string) {
    return OfferRepository.setOfferAsDiscarded(offerId)
  },

  contract: function() {
    return OfferRepository.constract()
  },

  getOfferDocument: async function(id: string) {
    try {
      const document = await OfferRepository.getOfferDocument(id)
      return document.data
    } catch (error) {
      console.log(error)
    }
  },

  getOfferData: async function() {
    try {
      const offer = await OfferRepository.getOfferData()
      return offer.data
    } catch (error) {
      console.log(error)
    }
  },

  getOffersList: function(page?: number, pageSize?: number) {
    return OfferRepository.getOffersList(page, pageSize)
  },

  getExpiredOffersList: function(page?: number, pageSize?: number) {
    return OfferRepository.getExpiredOffersList(page, pageSize)
  },

  getPoliciesList: function(page?: number, pageSize?: number) {
    return OfferRepository.getPoliciesList(page, pageSize)
  },

  getOfferPrice: async function() {
    try {
      const price = await OfferRepository.getOfferPrice()
      return price.data
    } catch (error) {
      console.log(error)
      throw error
    }
  },

  getOfferPDF: async function(offerId: string) {
    const pdfFile = await OfferRepository.getOfferPDF(offerId)

    return new Blob([pdfFile], {
      type: 'application/pdf',
    })
  },

  saveOfferDocument: async function(document: OfferDocumentDTO) {
    return OfferRepository.putOfferDocument(document)
  },

  saveOfferData: async function(offer: OfferData) {
    return OfferRepository.putOfferData(offer)
  },

  saveAndRetrieve: async function() {
    return OfferRepository.saveAndRetrieve()
  },

  sendOfferByEmail: async function(offerId: string) {
    return OfferRepository.sendOfferByEmail(offerId)
  },
}
